import { inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { createCryptotokenSlotsEffects } from './cryptotoken-slots.feature';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { map } from 'rxjs';

@Injectable()
export class CryptotokenSlotsEffects {
  private action$ = inject(Actions);
  private store = inject(Store);
  private apiService = inject(ApiService);
  private toastrService = inject(ToastrService);
  private langService = inject(LangService);
  private defaultErrorMessage =
    this.langService.lang.shared.fetchingErrors.calist;

  private effects = createCryptotokenSlotsEffects(this.action$, this.store, {
    fetchParams: () =>
      this.apiService
        .cryptotokenSlots()
        .pipe(map(slots => slots.map(({ name }) => name))),
    notifyError: () => this.toastrService.error(this.defaultErrorMessage),
  });

  ensure$ = this.effects.ensure$;
  fail$ = this.effects.fail$;
  fetch$ = this.effects.fetch$;
}
